import { FC, useContext } from 'react';
import {
  WeatherContext,
  WeatherContextType,
} from '../../../context/WeatherContext';
import Link from 'components/AppSafeLink/AppSafeLink';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

interface WeatherGlanceProps {
  latitude?: number;
  longitude?: number;
  cityName?: string;
}

const WeatherGlance: FC<WeatherGlanceProps> = ({
  latitude,
  longitude,
  cityName,
}) => {
  const context = useContext<WeatherContextType>(WeatherContext);
  const weather = context.weatherData?.currentWeather;
  const isLoading = context.isLoading;
  const time = dayjs(new Date()).tz('America/Chicago');

  // Build the weather link - use city-specific if coords provided, otherwise general page
  const weatherLink =
    latitude && longitude && cityName
      ? `/weather?latitude=${latitude}&longitude=${longitude}&city=${encodeURIComponent(
          cityName
        )}`
      : '/weather';

  if (isLoading) {
    return (
      <div
        className="home-weather-glance-skeleton"
        role="status"
        aria-label="Weather loading"
      >
        <div className="skeleton-block skeleton-temp" aria-hidden="true" />
        <div className="skeleton-block skeleton-icon" aria-hidden="true" />
        <div className="skeleton-block skeleton-btn" aria-hidden="true" />
      </div>
    );
  }

  if (!weather) return null;

  return (
    <div className="home-weather-glance">
      <div className="home-weather-glance-temp">
        {weather.temperature ? <>{weather.temperature}º</> : null}
        <div className="home-weather-time">{time.format('h:mm A')}</div>
      </div>
      <div className="home-weather-glance-conditions">
        {weather.weatherCodeIconPath && weather.weatherImageAlt[0] && (
          <img
            className="weatherIcon weatherIcon-current"
            src={`/siteicons/weatherkitIcons/svg/${weather.weatherCodeIconPath}.svg`}
            alt={`${
              weather.weatherImageAlt[0] &&
              weather.weatherImageAlt[0].description
            }`}
            width="40"
            height="40"
          />
        )}
      </div>
      <Link href={weatherLink} className="btn btn-primary btn-slim type-sm">
        Weather &amp; Updraft&thinsp;&reg;
      </Link>
    </div>
  );
};

export default WeatherGlance;
